import { useParams } from 'react-router-dom'

export const useRouteParams = (...params: string[]) => {
    const routeParams = useParams()

    return Object.keys(routeParams).map((key, index) => {
        return routeParams[params[index]] ?? ''
    })
}
